import { create } from 'zustand';

interface DialogsState {
  shareholderSlug?: string;
  setShareholderSlug: (shareholderSlug: string) => void;
  documentSlug?: string;
  setDocumentSlug: (documentSlug: string) => void;
  documentUrl: string;
  setDocumentUrl: (documentUrl: string) => void;
}

const useDialogsStore = create<DialogsState>((set) => ({
  shareholderSlug: '',
  setShareholderSlug: (shareholderSlug: string) => set({ shareholderSlug }),
  documentSlug: '',
  setDocumentSlug: (documentSlug: string) => set({ documentSlug }),
  documentUrl: '',
  setDocumentUrl: (documentUrl: string) => set({ documentUrl })
}));

const useDialogVizualizeDocumentStore = create((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open })
}));

const useDialogApprovalDocumentStore = create((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open })
}));

const useDialogReproveDocumentStore = create((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open })
}));

const useDialogMoreInfoDocumentStore = create((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open })
}));

const useDialogCompleteRegisterStore = create((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open })
}));

export {
  useDialogApprovalDocumentStore,
  useDialogCompleteRegisterStore,
  useDialogMoreInfoDocumentStore,
  useDialogReproveDocumentStore,
  useDialogVizualizeDocumentStore,
  useDialogsStore
};
